/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * dogma_effect object
 * @export
 * @interface GetUniverseTypesTypeIdDogmaEffect
 */
export interface GetUniverseTypesTypeIdDogmaEffect {
    /**
     * effect_id integer
     * @type {number}
     * @memberof GetUniverseTypesTypeIdDogmaEffect
     */
    effectId: number;
    /**
     * is_default boolean
     * @type {boolean}
     * @memberof GetUniverseTypesTypeIdDogmaEffect
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the GetUniverseTypesTypeIdDogmaEffect interface.
 */
export function instanceOfGetUniverseTypesTypeIdDogmaEffect(value: object): value is GetUniverseTypesTypeIdDogmaEffect {
    if (!('effectId' in value) || value['effectId'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function GetUniverseTypesTypeIdDogmaEffectFromJSON(json: any): GetUniverseTypesTypeIdDogmaEffect {
    return GetUniverseTypesTypeIdDogmaEffectFromJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdDogmaEffectFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseTypesTypeIdDogmaEffect {
    if (json == null) {
        return json;
    }
    return {
        
        'effectId': json['effect_id'],
        'isDefault': json['is_default'],
    };
}

export function GetUniverseTypesTypeIdDogmaEffectToJSON(json: any): GetUniverseTypesTypeIdDogmaEffect {
    return GetUniverseTypesTypeIdDogmaEffectToJSONTyped(json, false);
}

export function GetUniverseTypesTypeIdDogmaEffectToJSONTyped(value?: GetUniverseTypesTypeIdDogmaEffect | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effect_id': value['effectId'],
        'is_default': value['isDefault'],
    };
}

